import { render, staticRenderFns } from "./files-gallery.vue?vue&type=template&id=8186a1fa&scoped=true"
import script from "./files-gallery.vue?vue&type=script&lang=js"
export * from "./files-gallery.vue?vue&type=script&lang=js"
import style0 from "./files-gallery.vue?vue&type=style&index=0&id=8186a1fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8186a1fa",
  null
  
)

export default component.exports